import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';
import { ComponentChanges } from '../../../../utils/types/component-changes';
import { DrawingShape, DrawingUnit } from '../../core';
import { DepthUnit } from '../../core/constants';
import { GetDefaultDepthUnit, IsCubic, IsImperial, IsSquare, IsYard } from '../../core/functions';

@Component({
    selector: 'app-take-off-drawing-depth',
    templateUrl: './take-off-drawing-depth.component.html',
    styleUrls: ['./take-off-drawing-depth.component.scss'],
    standalone: false,
})
export class TakeOffDrawingDepthComponent implements OnChanges, OnInit {
    // @ts-ignore TS2564
    @Input() shape: string;
    // @ts-ignore TS2564
    @Input() unit: string;

    // @ts-ignore TS2564
    @Input() depth: number;
    // @ts-ignore TS2564
    @Input() depthUnit: string;

    @Output() depthChanges = new EventEmitter<number>();
    @Output() depthUnitChanges = new EventEmitter<string>();

    public isDepthEnabled = false;
    // @ts-ignore TS2564
    public title: string;

    // @ts-ignore TS2564
    public depthUnits: string[];
    // @ts-ignore TS2564
    public depthUnitForm: UntypedFormGroup;

    constructor(private readonly formBuilder: UntypedFormBuilder) {}

    ngOnChanges(changes: ComponentChanges<TakeOffDrawingDepthComponent>): void {
        if (changes.shape?.currentValue !== changes.shape?.previousValue) {
            this.isDepthEnabled = this.checkIsDepthEnabled(this.unit);
        }

        if (changes.unit?.currentValue) {
            this.isDepthEnabled = this.checkIsDepthEnabled(this.unit);
            this.title = IsCubic(this.unit) ? 'Depth' : 'Height';
            this.depthUnits = IsImperial(this.unit) || IsYard(this.unit) ? [DepthUnit.ft] : [DepthUnit.mm, DepthUnit.cm, DepthUnit.m];
        }

        if (this.depthUnitForm) {
            // @ts-ignore TS2532
            if (changes.depth?.currentValue >= 0 && this.depthUnitForm.controls.depth.value !== this.depth) {
                // @ts-ignore TS2532
                this.depthUnitForm.controls.depth.setValue(this.depth);
            }

            // @ts-ignore TS7053
            if (changes.depthUnit?.currentValue && this.depthUnitForm.controls.depthUnit.value !== this.depthUnit) {
                // @ts-ignore TS2532
                this.depthUnitForm.controls.depthUnitName.setValue(this.getUnitName());
            }
        }
    }

    ngOnInit(): void {
        this.initdepthUnitForm();
    }

    private initdepthUnitForm() {
        this.depthUnitForm = this.formBuilder.group({
            depth: [this.depth, { updateOn: 'blur' }],
            depthUnit: [this.getDepthUnit()],
        });

        // @ts-ignore TS2532
        this.depthUnitForm.controls.depth.valueChanges.pipe(distinctUntilChanged()).subscribe((depth: number) => {
            this.depthChanges.emit(depth);
        });

        // @ts-ignore TS2532
        this.depthUnitForm.controls.depthUnit.valueChanges.subscribe((depthUnit: string) => {
            // @ts-ignore TS7053
            this.depthUnitChanges.emit(depthUnit);
        });
    }

    private checkIsDepthEnabled(unit: string): boolean {
        const enabledForDepth = Object.keys(DrawingUnit).filter((unit) => unit !== DrawingUnit.ea);

        return IsCubic(unit) || (IsSquare(unit) && this.shape === DrawingShape.Line);
    }

    private getDepthUnit(): string {
        if (IsImperial(this.unit) || IsYard(this.unit)) {
            return DepthUnit.ft;
        }

        // @ts-ignore TS2322
        return this.depthUnit || GetDefaultDepthUnit(this.unit);
    }
}

@NgModule({
    declarations: [TakeOffDrawingDepthComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    exports: [TakeOffDrawingDepthComponent],
})
export class TakeOffDrawingDepthModule {}
